import { faArrowLeft, faPlus, faUpload, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Form, Row, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Trash from "../../../../assets/images/trash.png";
import Header from "../../../../Components/Header/Header";
import { withRFSToken } from '../../../../Services/axios.js';
import XLSFILE from '../../../../assets/Add_ULD.xlsx'
import { GETTYPECODE, GETDESTINATION, GETOWNERCODE, GETCONDITIONCODE, ULDADDRESSSAVE, SAVEULDSTOCK } from '../../../../Utils/conts.js';
import Overview from '../../../Airline/ULDControl/components/inc/Overview';
import * as XLSX from 'xlsx';
import { CallApi, jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const AddUldForwarder = ({ onBack }) => {

  const isMounted = useRef(false);
  const [getTypeCodes, setGetTypeCodes] = useState([]);
  const [getDestination, setGetDestination] = useState([]);
  const [getDepartment, setGetDepartment] = useState([]);
  const [getOwnerCodes, setGetOwnerCode] = useState([]);
  const [getCondCodes, setGetCondCode] = useState([]);
  const [handlerNames, setHandlerNames] = useState([]);
  const [selectedHandler, setSelectedHandler] = useState(null);
  const [inputAddress, setInputAddress] = useState({
    id: '', company_name: '', agent_or_handler: 'H', address: '', email: '', phone_number: ''
  });
  const [address, setAddress] = useState([]);
  const [selectedStationId, setSelectedStationId] = useState(null);
  const [airlineNames, setAirlineNames] = useState([]);

  const pages = localStorage.getItem('F_AddULD');
  const gridRef = useRef(null);

  const [gridSelect, setGridSelect] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [uldDetails, setUldDetails] = useState(null);

  const fetchDestination = async () => {
    try {

      const res = await withRFSToken.post('uld-setting/get-station-list', {})
        .then(function (res) {
          const innerData = res.data.Rows;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.station_short_code,
            label: item.station_short_code,
          })) : [];
          setGetDestination(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchHandler = async (stationCode, handlerId) => {
    try {
      const res = await withRFSToken.post('uld-from/get-forwarder-handler', { station_code: stationCode });

      if (res.data.response_code === 200) {
        const innerData = res.data.response_data;
        if (innerData.length == 1) {
          setFormData(prevFormData => ({
            ...prevFormData,
            handler_id: innerData[0].value
          }));
        } else {

        }
        setHandlerNames(innerData);
        // if (!innerData || innerData.length === 0) {
        //   if (uldDetails?.handler_id && uldDetails?.handler_lable) {
        //     const handlerOption = [{
        //       value: uldDetails.handler_id,
        //       label: uldDetails.handler_lable
        //     }];
        //     setHandlerNames(handlerOption);
        //   } else {
        //     setHandlerNames([]);
        //   }
        // } else {
        //   setHandlerNames(innerData);
        //   setHandlerNames([]);
        // }
      } else {
        toast.error(res.data.response_msg);
        setHandlerNames([]);
      }
    } catch (error) {
      console.error('Error fetching handler data:', error);
      toast.error('Failed to fetch handlers');
    }
  };
  const fetchData = async () => {
    try {

      const res = await withRFSToken.post(GETTYPECODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.uld_typecode,
            label: item.uld_typecode
          })) : [];
          setGetTypeCodes(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchOwnerCode = async () => {
    try {
      const res = await withRFSToken.post(GETOWNERCODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.IATA,
            label: item.IATA,
            airline_name: item.airline_name
          })) : [];
          setGetOwnerCode(transformedData);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDepartment = async () => {
    try {

      const res = await withRFSToken.post('uld-from/get-forwarder-department', {})
        .then(function (res) {
          const innerData = res.data.response_data;
          // const transformedData = innerData ? innerData.map(item => ({
          //   value: item.department_id,
          //   label: item.department_code,
          // })) : [];
          setGetDepartment(innerData);
          if (res.data.response_code === 200) {
            const innerData = res.data.response_data;
            if (innerData.length == 1) {
              setFormData(prevFormData => ({
                ...prevFormData,
                department: innerData[0].value
              }));
            } else {

            }
            setGetDepartment(innerData);
          } else {
            toast.error(res.data.response_msg);
            setGetDepartment([]);
          }

        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchCondCode = async () => {
    try {

      const res = await withRFSToken.post(GETCONDITIONCODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          setGetCondCode(innerData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchUldDetails = (uldId) => {
    CallApi({
      endPoint: 'forwarder-uld-control/get-uld-details',
      payload: { uld_id: uldId },
      onSuccess: (data) => {
        const resCode = data.data.response_code;
        if (resCode === 200) {
          const innerData = data.data.response_data;
          setUldDetails(innerData);
          if (innerData.handler_station_code) {
            fetchHandler(innerData.handler_station_code, Number(innerData.luc_out));
          }
          setFormData(prevFormData => ({
            ...prevFormData,
            origin: innerData.origin,
            handler_id: Number(innerData.luc_out),
            department: innerData.dep_map_id,
            ulds: [{
              id: 0,
              uld_id: innerData.id,
              type_code: innerData.type_code,
              serial_number: innerData.serinal_number,
              owner_code: innerData.owner_code,
              condition_code: innerData.condition_code,
              airway_bill: innerData.awb_number
            }]
          }));
        }
      },
      onError: (msg) => toast.error(msg)
    });
    // try {
    //   const res = await withRFSToken.post('uld-control/planning-stock-details', { uld_id: uldId });
    //   if (res.data.response_code === 200) {
    //     const innerData = res.data.response_data;
    //     setUldDetails(innerData);

    //     if (innerData.origin) {
    //       setUldDetails(innerData);
    //       await fetchHandler(innerData.origin, innerData.luc_out);
    //     }
    //     setFormData(prevFormData => ({
    //       ...prevFormData,
    //       origin: innerData.origin,
    //       handler_id: innerData.handler_id,
    //       department: innerData.department,
    //       ulds: innerData.ulds.map((uld, index) => ({
    //         id: (index + 1).toString(),
    //         uld_id: innerData.uld_id,
    //         type_code: uld.type_code,
    //         serial_number: uld.serial_number,
    //         owner_code: uld.owner_code,
    //         condition_code: uld.condition_code,
    //         airway_bill: uld.airway_bill
    //       }))
    //     }));
    //   } else if (res.data.response_code === 400) {
    //     toast.error(res.data.response_msg);
    //   }
    // } catch (error) {
    //   console.error('Error fetching ULD details:', error);
    //   toast.error('Failed to fetch ULD details');
    // }
  };
  const uldId = localStorage.getItem('F_EditULD');
  useEffect(() => {

    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API

    if (uldId) {
      fetchUldDetails(uldId);
    }

    fetchData();
    fetchDestination();
    fetchDepartment();
    fetchOwnerCode();
    fetchCondCode();
    setIsLoading(false);
    setGridData([])
    isMounted.current = true;
  }, []);

  const [formData, setFormData] = useState(
    {
      id: '1',
      // status: '',
      origin: '',
      handler_id: '',
      department: '',

      ulds: [
        { id: '1', type_code: '', serial_number: '', owner_code: '', condition_code: 'SER', airwayNumber: '' }
      ]
    }
  );

  const addULDStack = () => {
    const lastId = formData.ulds.length > 0 ? parseInt(formData.ulds[formData.ulds.length - 1].id) : 0;
    const newId = (lastId + 1).toString();
    setFormData(prevFormData => ({
      ...prevFormData,
      ulds: [
        ...prevFormData.ulds,
        {
          // id: (prevFormData.uldStack.length + 1).toString(),
          id: newId,
          type_code: '',
          serial_number: '',
          owner_code: '',
          condition_code: 'SER',
          airwayNumber: '',
          asset_type: false
        }
      ]
    }));
  };
  const removeULDStack = (uldInfoId) => {
    setFormData(prevFormData => {
      return {
        ...prevFormData,
        ulds: prevFormData.ulds.filter(stack => stack.id !== uldInfoId)
      };
    });
  };
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData(prevFormData => {
      const newFormData = { ...prevFormData, [name]: type === 'checkbox' ? checked : value };

      // If the field being changed is owner_code, update airline_name accordingly
      if (name === 'destination') {
        const selectedOwner = getDestination.find(owner => owner.port_code === value);
        if (selectedOwner) {
          newFormData.airline_name = selectedOwner.carrierName;
        } else {
          newFormData.airline_name = '';
        }
      }

      return newFormData;
    });
  };
  const handleULDInputChange = (uldInfoId, fieldName, value) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      ulds: prevFormData.ulds.map(stack => {
        if (stack.id === uldInfoId) {
          const updatedStack = { ...stack, [fieldName]: value };

          // If the owner code is being changed, update airline_name
          if (fieldName === "owner_code") {
            const selectedOwner = getOwnerCodes.find(option => option.value === value);
            if (selectedOwner) {
              updatedStack.airline_name = selectedOwner.airline_name;
            }
          } else if (fieldName === 'airway_bill') {
            value = handleChange(value);
          }

          return updatedStack;
        }
        return stack;
      })
    }));
  };

  const handleChange = (value) => {
    value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
    let formattedValue = '';

    // Add a hyphen after the third character
    if (value.length > 3) {
      formattedValue += value.substr(0, 3) + '-';
      value = value.substr(3);
    }

    // Add a space after the eighth character
    if (value.length > 4) {
      formattedValue += value.substr(0, 4) + ' ';
      value = value.substr(4);
    }

    formattedValue += value;
    return formattedValue.substr(0, 13);
  };


  // ADD ADDRESS



  let destLabel;
  if (selectedStationId) {
    const idMatch = getDestination.find(option => option.station_id == selectedStationId);

    destLabel = idMatch.label;
  }

  const validateAddressData = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


    const validateEmail = (email) => {
      return emailRegex.test(email);
    };
    if (!inputAddress.company_name) {
      console.log('Text input is required');
      toast.error('Company Name must not be blank');
      isValid = false;
    } else if (!inputAddress.agent_or_handler) {
      console.log('Text input is required');
      toast.error('Please select Agent or Handler');
      isValid = false;
    }

    else {
      return isValid;
    }
  };

  // ADD ADDRESS END
  const validateFormData = () => {
    let isValid = true;

    // Validate status
    // if (!formData.status) {
    //   toast.error('Please set Status');
    //   isValid = false;
    // }
    // Validate destination
    if (!formData.destination) {
      toast.error('Please select Station');
      isValid = false;
    }
    // Validate uldInfo array
    else {
      for (let i = 0; i < formData.ulds.length; i++) {
        const uld = formData.ulds[i];
        if (!uld.type_code) {
          toast.error('Please set Type Code');
          isValid = false;
          break;
        }
        if (!uld.serial_number) {
          toast.error('Please set Serial Number');
          isValid = false;
          break;
        }
        if (!uld.owner_code) {
          toast.error('Please set Owner Code');
          isValid = false;
          break;
        }
        if (!uld.condition_code) {
          toast.error('Please set Condition Code');
          isValid = false;
          break;
        }
      }
    }
    return isValid;
  };

  const handleSave = async () => {
    // if (validateFormData()) {
    const tabName = localStorage.getItem('F_AddULD');
    // const tabName = localStorage.getItem('Maintab');
    const transformedData = {
      ...formData,
      tab_name: tabName,
      ulds: formData.ulds.map(stack => ({
        ...stack,

      }))
    };
    console.log('Saving data:', transformedData);
    try {
      // const res = await withRFSToken.post('uld-from/add-edit-forwarder-uld', transformedData);
      const res = await withRFSToken.post('forwarder-uld-control/save-uld', transformedData);
      if (res.data.response_code == 200) {
        toast.success('New Stock Saved')
        const innerData = res.data.response_data;
        onBack()
        // if (tabName === 'uldstock') {
        //   window.location.href = '/ULDForwarder/ULDStock';
        // } else {
        //   window.location.href = '/ULDForwarder/Planning';
        // }
      } else {
        toast.error(res.data.response_msg);
      }


    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleModalOpen = (contentType) => {
    setModalContent(contentType)
    setShowModal(true);
  };

  const [addressFor, setAddressFor] = useState('');
  const [addressModalShow, setAddressModalShow] = useState(false);
  const addressModalClose = () => setAddressModalShow(false);
  const [modalContent, setModalContent] = useState('');
  const [modalRadioValue, setModalRadioValue] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const [fileName, setFileName] = useState('');
  const addressModalOpen = (addressType) => {
    setAddressFor(addressType);
    setAddressModalShow(true)
  }

  const handleModalClose = () => { setShowModal(false); setModalRadioValue('') };
  const handleAddressChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox' && name === 'regd') {
      setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
    } else {
      setInputAddress({ ...inputAddress, [name]: value });
    }
    console.log(inputAddress);
  };

  const addAddress = async (e) => {
    console.log('444', inputAddress);
    if (validateAddressData()) {
      e.preventDefault();
      // const newAddressID = Math.floor(Math.random() * 1000000);
      const stationid = selectedStationId;
      const NewInputAddress = { ...inputAddress, station_id: stationid };
      console.log("🚀 ~ addAddress ~ NewInputAddress:", NewInputAddress)

      if (NewInputAddress) {
        try {
          const res = await withRFSToken.post(ULDADDRESSSAVE, NewInputAddress)
            .then(function (res) {
              // const innerData = res;
              // console.log("🚀 ~ .then ~ innerData:", innerData)
              if (res.data.response_code == 200) {
                const newAddress = res.data.response_data;
                setAddress(newAddress);
                fetchDestination();
                setHandlerNames(prevHandlerNames => [
                  ...prevHandlerNames,
                  newAddress
                ]);
                setInputAddress({
                  station_address_id: '', company_name: '', agent_or_handler: 'H', address: '', email: '', phone_number: ''
                });
                console.log(address);
                addressModalClose();
              } else {
                toast.error(res.data.response_msg);
              }
            });

        } catch (error) {
          console.error('Error sending request:', error);
        }
      }

    }
  }

  const handleConfirmation = (confirm) => {
    if (confirm) {
      setShowModal(false);
      // window.location.href = pages === "planning" ? "/ULDForwarder/Planning" : "/ULDForwarder/ULDStock";
      onBack(true);
    } else {
      setShowModal(false);
    }
  }

  const handleModalUpdate = () => {
    const updatedAssetType = modalRadioValue.assetType === 'O' ? false : true;
    const updatedFormData = {
      ...formData,
      asset_type: updatedAssetType,
      ulds: formData.ulds.map(stack => ({
        ...stack,
        asset_type: updatedAssetType
      }))
    };
    setFormData(updatedFormData);
    setModalRadioValue('')
    setShowModal(false);
  };

  const handleModalRadioChange = (event) => {
    const { name, value } = event.target;
    setModalRadioValue({ [name]: value });
  };

  const handleFileChange = (event) => {
    // console.log("🚀 ~ handleFileChange ~ event:", event)
    setSelectedFile(event.target.files[0]);

    const input = event.target;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      setFileName(file.name);
      setSelectedFile(file);

    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file first!");
      return;
    }


    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        console.log("🚀 ~ handleUpload ~ json:", json)
        setFormData(prevFormData => {
          const startId = prevFormData.ulds.length + 1;

          const transformedData = json.map((item, index, value) => {
            let transformedConditionCode;
            switch (item["Condition Code"]?.toString().trim().toLowerCase()) {
              case "serviceable":
                transformedConditionCode = "SER";
                break;
              case "damaged":
                transformedConditionCode = "DAM";
                break;
              case "discarded":
                transformedConditionCode = "DIS";
                break;
              default:
                transformedConditionCode = item["Condition Code"]?.toString().trim() || ""; // Keep original if not matched
            }
            return {
              id: startId + index, // Assign ID
              type_code: item["Type Code"]?.toString().trim() || "",
              serial_number: item["Serial Number"]?.toString().trim() || "",
              owner_code: item["Owner Code"]?.toString().trim() || "",
              condition_code: transformedConditionCode,
              asset_type: item["Asset Type"]?.toString().trim() === 'Owned' ? false : true
            }
          });

          console.log("🚀 ~ transformedData ~ transformedData:", transformedData);
          const shouldKeepPreviousData = formData.ulds.some(
            section => section.type_code || section.serial_number || section.owner_code
          );

          return {
            ...prevFormData,
            ulds: shouldKeepPreviousData ? [...prevFormData.ulds, ...transformedData] : [...transformedData]
          };
        });
        setSelectedFile(null);
        setFileName('');
        // setExceljsondata(json);
        setShowModal(false);
      };
      reader.readAsBinaryString(selectedFile);
    } else {
      toast.error("All Fields Are Mandatory", { autoClose: 1000 });
    }


  };

  const handleDownloadClick = () => {
    const a = document.createElement('a');
    a.href = XLSFILE;
    a.download = 'Add_ULD.xlsx'; // Name for the downloaded file
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // useEffect(() => { }, [gridData])

  let checkUlds = [];
  useEffect(() => {
    if (gridRef?.current) {
      // var token = "Bearer " + localStorage.ULD;
      jqxCookieCall();
      let tabType = '';
      // if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
      // const endpoint = tabType === 'A' 
      //     ? 'uld-control/active-uld-planning' 
      //     : 'uld-control/archive-uld-planning';
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'created', type: 'string' },
          { name: 'uld_number', type: 'string' },
          { name: 'type_code', type: 'string' },
          { name: 'serial_number', type: 'string' },
          { name: 'owner_code', type: 'string' },
          { name: 'condition_code', type: 'string' },
          { name: 'condition_code_val ', type: 'string' },
          { name: 'airline', type: 'string' },
          { name: 'origin', type: 'string' },
          { name: 'on_loan', type: 'string' },
          { name: 'airway_bill', type: 'string' },
          { name: 'status', type: 'string' },
          { name: 'archive_date', type: 'string' },
          { name: 'uld_id', type: 'string' },

        ],
        // id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}forwarder-uld-control/get-uld-list?tab_name=A&main_tab=P`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 50,
        filter: function () {
          // if (allfilters.length > 0) {
          //     setFilterApplied(true);
          //     filterForCheck = true;
          // } else {
          //     setFilterApplied(false);
          //     filterForCheck = false;
          // }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          // setTotalRows({ totalUlds: data.activeCount });
          // setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [

        { text: 'ULD Number', filtertype: 'textbox', datafield: 'uld_number', width: '20%', cellclassname: '', },

        { text: 'Type Code', filtertype: 'textbox', datafield: 'type_code', width: '15%', cellclassname: '', },
        { text: 'Serial Number', filtertype: 'textbox', datafield: 'serial_number', width: '20%', cellclassname: '', },
        { text: 'Owner Code', filtertype: 'textbox', datafield: 'owner_code', width: '15%', cellclassname: '', },
        {
          text: 'Condition Code', filtertype: 'checkedlist', filterable: true,
          filteritems: [
            { label: 'Serviceable', value: 'SER' },
            { label: 'Damaged', value: 'DAM' },
            { label: 'Discarded', value: 'DIS' }
          ],
          datafield: 'condition_code', width: '20%', cellclassname: '',
        },


      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 750,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ['20', '50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
        rendered: function () {
          const rows = window.$(gridRef.current).jqxGrid('getrows');
          (checkUlds).forEach(uldNumber => {
            rows.forEach((element, index) => {
              if (element.uld_number == uldNumber) {
                window.$(gridRef.current).jqxGrid('selectrow', index);
              }
            });
          });
        }
      };
      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
      // window.$(gridRef.current).on('click', '.row_edit', function () {
      //     const rowDiv = window.$(this).closest('[role="row"]');
      //     const rowIndex = window.$(rowDiv).attr('row-id');
      //     const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
      //     const dataToSend = {
      //         uld_number: rowData.uld_number,
      //         type_code: rowData.type_code,
      //         serial_number: rowData.serial_number,
      //         owner_code: rowData.owner_code,
      //         condition_code: rowData.condition_code,
      //         asset_type: rowData.asset_type == 'Y' ? false : true
      //     };
      //     setEditData(dataToSend);
      //     setShowEdit(true);
      // });
      // window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
      //     window.$(row).on('mouseover', () => {
      //         window.$(row).addClass('row-hover');
      //     });
      //     window.$(row).on('mouseout', () => {
      //         window.$(row).removeClass('row-hover');
      //     });
      // });
      window.$(gridRef.current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.uld_number;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }

          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRef.current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRef.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.uld_number;
          setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
          // if(filterForCheck!=true){
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
          // }
          // console.log(checkUlds);

        }
      });


    }
  }, [gridData]);

  // const handleAddUld = () => {
  //   console.log("formData before , ", gridSelect)
  //   const existingEntries = new Set(formData.ulds.map(row =>
  //     `${row.airwayNumber}-${row.type_code}-${row.serial_number}-${row.owner_code}`
  //   ));

  //   const filteredRows = gridSelect.filter(row =>
  //     !existingEntries.has(`${row.airwayNumber}-${row.type_code}-${row.serial_number}-${row.owner_code}`)
  //   );

  //   if (filteredRows.length === 0) return;

  //   const updatedUlds = [...formData.ulds];

  //   // Check for truly empty row (ignore id and condition_code)
  //   const emptyIndex = updatedUlds.findIndex(row =>
  //     row.airwayNumber === '' &&
  //     row.type_code === '' &&
  //     row.serial_number === '' &&
  //     row.owner_code === ''
  //   );

  //   let nextId = updatedUlds.length > 0
  //     ? Math.max(...updatedUlds.map(r => parseInt(r.id) || 0)) + 1
  //     : 1;

  //   const newRows = [];

  //   filteredRows.forEach((row, i) => {
  //     // Map the condition code from full form to short form
  //     const conditionCodeMap = {
  //       'Serviceable': 'SER',
  //       'Damaged': 'DAM',
  //       'Discarded': 'DIS'
  //     };

  //     const newRow = {
  //       ...row,
  //       id: (emptyIndex !== -1 && i === 0) ? updatedUlds[emptyIndex].id : nextId.toString(),
  //       condition_code: conditionCodeMap[row.condition_code] || row.condition_code
  //     };

  //     if (i === 0 && emptyIndex !== -1) {
  //       updatedUlds[emptyIndex] = newRow;
  //     } else {
  //       updatedUlds.push(newRow);
  //       nextId++;
  //     }

  //     newRows.push(newRow);
  //   });

  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     ulds: updatedUlds
  //   }));

  //   gridSelect.forEach(selectedItem => {
  //     const selectedRowBoundIndex = selectedItem.boundindex;
  //     if (selectedRowBoundIndex !== undefined && selectedRowBoundIndex !== null) {
  //       window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
  //     }
  //   });
  // };

  const handleAddUld = () => {
    console.log("formData before , ", gridSelect);
    const existingUlds = formData.ulds.filter(row =>
      row.airwayNumber !== '' || row.type_code !== '' || row.serial_number !== '' || row.owner_code !== ''
    );
    const originToMatch = existingUlds[0]?.origin || gridSelect[0]?.origin;
    const handlerToMatch = existingUlds[0]?.handler_id || gridSelect[0]?.handler_id;
    const mismatchedUld = gridSelect.find(row =>
      row.origin !== originToMatch || row.handler_id !== handlerToMatch
    );

    if (mismatchedUld) {
      toast.error('Selected ULDs are from different Handlers.');
      return;
    }

    const existingEntries = new Set(formData.ulds.map(row =>
      `${row.airwayNumber}-${row.type_code}-${row.serial_number}-${row.owner_code}`
    ));

    const filteredRows = gridSelect.filter(row =>
      !existingEntries.has(`${row.airwayNumber}-${row.type_code}-${row.serial_number}-${row.owner_code}`)
    );

    if (filteredRows.length === 0) return;

    const updatedUlds = [...formData.ulds];
    const emptyIndex = updatedUlds.findIndex(row =>
      row.airwayNumber === '' && row.type_code === '' &&
      row.serial_number === '' && row.owner_code === ''
    );

    let nextId = updatedUlds.length > 0
      ? Math.max(...updatedUlds.map(r => parseInt(r.id) || 0)) + 1
      : 1;

    const conditionCodeMap = {
      'Serviceable': 'SER',
      'Damaged': 'DAM',
      'Discarded': 'DIS'
    };

    filteredRows.forEach((row, i) => {
      const newRow = {
        ...row,
        id: (emptyIndex !== -1 && i === 0) ? updatedUlds[emptyIndex].id : nextId.toString(),
        condition_code: conditionCodeMap[row.condition_code] || row.condition_code
      };

      if (i === 0 && emptyIndex !== -1) {
        updatedUlds[emptyIndex] = newRow;
      } else {
        updatedUlds.push(newRow);
        nextId++;
      }
    });

    setFormData(prev => ({ ...prev, ulds: updatedUlds }));

    gridSelect.forEach(item => {
      const selectedRowBoundIndex = item.boundindex;
      if (selectedRowBoundIndex !== undefined && selectedRowBoundIndex !== null) {
        window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
      }
    });
  };



  return (

    <>
      {console.log('formData', formData)}
      {console.log("handlername", handlerNames)}
      {/* <div className="">
        <Header /> */}
      <div className='main-panel'>
        <Link to='#' onClick={() => onBack(true)} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>

        <Row className='mt-3'>

          <Col sm={pages === "planning" ? "12" : (uldId ? '12' : "8")}>
            <div className={pages === "planning" ? "addstock" : (uldId ? 'addstock' : "addstock w-100")}>
              <div className='d-flex justify-content-between adds_top'>
                <h3>{uldId ? 'Edit ' : 'Add '}ULD - {pages === "planning" ? "Planning" : "Stock"}</h3>
                <span>ULD's <Badge>{formData.ulds.length}</Badge></span>
              </div>

              <div className='d-flex justify-content-between align-items-center mb-3 pb-3 ms-3 separate'>
                <div className='d-flex'>

                  <div>
                    <label className="form-label">Origin <span>*</span></label>
                    <Select
                      options={getDestination}
                      onChange={(selected) => {
                        // const selectedDestination = getDestination.find(option => option.value === selected.value);
                        // console.log("🚀 ~ NewStock ~ selectedDestination:", selectedDestination)
                        const updatedData = { ...formData, origin: selected.label, handler_id: '' };
                        setFormData(updatedData);
                        // setHandlerNames(selectedDestination ? selectedDestination.address : []);
                        // setSelectedStationId(selectedDestination.station_id);
                        fetchHandler(selected.value);
                      }}
                      placeholder="Origin"
                      className='autoslct'
                      name="destination"
                      value={getDestination.find(option => option.label === formData.origin)}
                    />

                  </div>
                  <div className='me-3 autoslct_big'>
                    <label className="form-label">Handler Name <span>*</span>{formData.destination ? <button onClick={() => addressModalOpen('destination')} className='raad_adrss'>+ Add</button> : ''}</label>

                    <Select
                      options={handlerNames}
                      onChange={(selected) => {
                        const updatedData = { ...formData, warehouse_id: selected.value, handler_org_id: selected.handler_org_id };
                        setFormData(updatedData);
                      }}
                      placeholder="Handler Name"
                      className='autoslct m-0'
                      name="handler_name"
                      // value={handlerNames?.find(option => {
                      //   console.log("Checking handler match:", {
                      //     handlerValue: option?.value,
                      //     formDataHandlerId: formData.handler_id,
                      //     match: option?.value === formData.handler_id
                      //   });
                      //   return option?.value === formData.handler_id;
                      // })}
                      value={handlerNames?.find(option => option.value == formData.handler_id)}
                      isDisabled={!formData.origin || !handlerNames?.length}
                    />
                  </div>
                  <div>
                    {pages === "uldstock" &&
                      <div className='autoslct_big'>
                        <label className="form-label">Department <span>*</span></label>
                        <Select
                          options={getDepartment}
                          onChange={(selected) => {
                            // const selectedDepartment = getDepartment.find(option => option.value === selected.value);
                            // console.log("🚀 ~ NewStock ~ selectedDestination:", selectedDepartment)
                            const updatedData = { ...formData, department: selected.value, };
                            setFormData(updatedData);
                            // setHandlerNames(selectedDepartment ? selectedDepartment.address : []);
                            // setSelectedStationId(selectedDepartment.station_id);
                          }}
                          placeholder="Department"
                          className='autoslct'
                          name="department"
                          value={getDepartment.find(option => option.value === formData.department)}
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div className='stck_middle'>
                {formData.ulds && formData.ulds.map((section, index) => {
                  return (
                    <div className='d-flex mb-3 sub_add' key={index}>

                      <div>
                        <Form.Label>Type Code <span>*</span></Form.Label>
                        <Select
                          options={getTypeCodes}
                          onChange={(e) => handleULDInputChange(section.id, 'type_code', e.value)}
                          placeholder="Type Code"
                          className='autoslct'
                          name="type_code"
                          value={getTypeCodes.find(option => option.value === section.type_code)}
                        />

                      </div>

                      <div>
                        <Form.Label>Serial Number <span>*</span></Form.Label>
                        <Form.Control type="text"
                          name='serial_number'
                          value={section.serial_number}

                          onChange={(e) => handleULDInputChange(section.id, 'serial_number', e.target.value)} />
                      </div>

                      <div>
                        <Form.Label>Owner Code <span>*</span></Form.Label>

                        <Select
                          options={getOwnerCodes}
                          onChange={(e) => handleULDInputChange(section.id, 'owner_code', e.value)}
                          placeholder="Owner Code"
                          className='autoslct'
                          name="owner_code"
                          value={getOwnerCodes.find(option => option.value === section.owner_code)}
                        />


                      </div>
                      {/* <div>
                            <Form.Label>Airline Name </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Airline Name"
                              value={section.airline_name || ""}
                              readOnly
                          />

                          </div> */}


                      <div>
                        <label className="form-label">Condition Code <span>*</span></label>
                        <select className="form-select" name="condition_code" value={section.condition_code}
                          onChange={(e) => handleULDInputChange(section.id, 'condition_code', e.target.value)}
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          {getCondCodes &&
                            Object.entries(getCondCodes).map(([key, label], index) => (
                              <option key={index} value={key}>
                                {label}
                              </option>
                            ))}
                        </select>
                      </div>


                      <div className=''>
                        <Form.Label>Airway Bill</Form.Label>
                        <Form.Control type="text"
                          name='airway_bill'
                          value={section.airway_bill || ''}
                          onChange={(e) => handleULDInputChange(section.id, 'airway_bill', handleChange(e.target.value))}
                        />
                      </div>
                      <div className='imag_trash'>
                        {formData.ulds.length > 1 && (
                          <img src={Trash} alt='' onClick={() => removeULDStack(section.id)} />
                        )}
                      </div>

                    </div>
                  )
                })}

                {!uldId && <div className='text-end'><Button variant="primary" className='stk_add' onClick={addULDStack}> <FontAwesomeIcon icon={faPlus} />Add ULD</Button></div>}
              </div>

              <div className='text-center mt-5'>
                <Button variant="light" className='stk_cancel' onClick={() => handleModalOpen('cancelForm')}>CANCEL</Button>
                <Button variant="primary" className='stk_save' onClick={handleSave}>SAVE</Button>
              </div>
            </div>
          </Col>
          {pages === "uldstock" &&
            <>
              {!uldId &&
                <Col sm="4">
                  {!isLoading &&
                    <div className='mb-3 nestedtabs rounded'>
                      <div className='d-flex justify-content-between charter_top'>
                        <h3>ULD Stock</h3>
                        <span className="selected">
                          Selected ULD <Badge>{gridSelect.length}</Badge>
                        </span>
                      </div>
                      <div ref={gridRef} className='ovgrid' ></div>
                      <div className='text-center mt-3'><Button variant="primary" className='aduld' onClick={handleAddUld}>  Add to ULD Stock  </Button></div>
                    </div>
                  }
                </Col>
              }
            </>

          }
        </Row>
      </div>
      <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          {modalContent === 'import' && (
            <>
              <h3>Import Excel</h3>
              <p>Upload the filled in template to add ULDs.</p>
              <div className='asset_midle'>

                <div className='upload_tmpl'>
                  <button onClick={handleDownloadClick}>
                    <FontAwesomeIcon icon={faDownload} />
                    <span>Download Template (Excel) </span>
                  </button>
                  <div className="form-group inputDnD">
                    <FontAwesomeIcon icon={faUpload} />
                    <input
                      type="file" className="form-control-file "
                      id="inputFile"
                      // accept=".xlsx, .xls, .csv"
                      onChange={handleFileChange}
                      data-title="Upload your file (Excel)" />

                    {/* {fileData && (
                          <div>
                              <h4>File Data:</h4>
                              <pre>{fileData}</pre>
                          </div>
                      )} */}
                  </div>
                </div>

                {fileName && (
                  <div className='rafilname'>
                    <p>File Name: {fileName}</p>
                  </div>
                )}


                {/* <Form.Control
                      type="file"
                      onChange={handleFileChange}
                      accept=".xlsx, .xls, .csv"
                  /> */}
              </div>
            </>
          )}
          {modalContent === 'assetTypeChange' && (
            <>
              <h3>All Asset Type Changes</h3>
              <p>Are sure you want to change all asset type?</p>
              <div className='asset_midle'>
                <Form.Check
                  type='radio'
                  label='Owned'
                  name='assetType'
                  id='own'
                  value='O'
                  checked={modalRadioValue.assetType === 'O'}
                  onChange={handleModalRadioChange}
                />
                <Form.Check
                  type='radio'
                  label='Lease'
                  name='assetType'
                  id='lease'
                  value='L'
                  checked={modalRadioValue.assetType === 'L'}
                  onChange={handleModalRadioChange}
                />
              </div>
            </>
          )}
          {modalContent === 'cancelForm' && (
            <>
              <h3>All changes will be destroyed. </h3>
              <p>If you proceed with the change, all changes will be removed.
                Are you sure you want to continue?</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {modalContent === 'assetTypeChange' ?
            (
              <>
                <Button variant='primary' onClick={handleModalUpdate}>
                  Update Asset Type
                </Button>
              </>
            ) : (modalContent === 'import' ? (
              <>
                <div className='d-flex w-50 mx-auto are_bottom'>
                  <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleUpload}>
                    Upload
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className='d-flex w-50 mx-auto are_bottom'>
                  <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                    No
                  </Button>
                  <Button variant="primary" onClick={() => handleConfirmation(true)} >
                    Yes
                  </Button>
                </div>
              </>
            ))}
        </Modal.Footer>
      </Modal>

      <Modal show={addressModalShow} onHide={addressModalClose} centered className='addfrom'>
        <Modal.Header closeButton onClick={addressModalClose}>
          <Modal.Title>Add Address  - {destLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <Form.Group className='mb-2'>
            <Form.Label>Company Name</Form.Label>
            <Form.Control type="text" onChange={handleAddressChange} name='company_name' placeholder="Company Name" />
          </Form.Group>
          <Form.Group className='mb-2'>
            <Form.Label>Agent or Handler</Form.Label>
            <Form.Check
              inline
              label="Agent"
              name="agent_or_handler"
              type='radio'
              id='export'
              value='A'
              checked={inputAddress.agent_or_handler === 'A'}
              onChange={handleAddressChange}
              disabled
            />

            <Form.Check
              inline
              label="Handler"
              value="H"
              name="agent_or_handler"
              type='radio'
              id='import'
              checked={inputAddress.agent_or_handler === 'H'}
              onChange={handleAddressChange}
            />
          </Form.Group>
          {inputAddress.agent_or_handler == 'A' &&
            <>
              <Form.Group className='mb-2'>
                <Form.Check
                  inline
                  label="External"
                  name="agent_type"
                  type='radio'
                  id='external'
                  value='E'
                  checked={inputAddress.agent_type === 'E'}
                  onChange={handleAddressChange}
                />

                <Form.Check
                  inline
                  label="Internal"
                  value="I"
                  name="agent_type"
                  type='radio'
                  id='internal'
                  checked={inputAddress.agent_type === 'I'}
                  onChange={handleAddressChange}
                />

              </Form.Group>
            </>
          }
          <Form.Group className='mb-2'>
            <Form.Label>Address </Form.Label>
            <Form.Control type="text" onChange={handleAddressChange} name='address' placeholder="Address" />
          </Form.Group>
          <Form.Group className='mb-2'>
            <Form.Label>Email ID</Form.Label>
            <Form.Control type="text" onChange={handleAddressChange} name='email' placeholder="E-mail" />
          </Form.Group>
          <Form.Group className='mb-2'>
            <Form.Label>Telephone No</Form.Label>
            <Form.Control type="number" onChange={handleAddressChange} name='phone_number' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }} placeholder="Number" />
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={addAddress}  >
            Add Address
          </Button>
        </Modal.Footer>
      </Modal>

      {/* </div> */}
    </>

  );
}

export default AddUldForwarder;